// src/api/mpo.js

import { http, getApiBase } from './http'

export async function getQuestionSets() {
  try {
    const response = await http.get('/mpo/question-sets/')
    return response.data
  } catch (error) {
    console.error('Ошибка загрузки наборов вопросов:', error)
    return []
  }
}

export async function getQuestionSet(questionSetId) {
  try {
    const response = await http.get(`/mpo/question-sets/${questionSetId}/`)
    return response.data
  } catch (error) {
    console.error('Ошибка загрузки набора вопросов:', error)
    return null
  }
}

export async function startSurvey(questionSetId, participants) {
  try {
    const response = await http.post('/mpo/surveys/start_survey/', {
      question_set_id: questionSetId,
      participants: participants,
    })
    return response.data
  } catch (error) {
    console.error('Ошибка при создании опроса:', error)
    throw error
  }
}

export async function submitChoice(surveyId, choice) {
  try {
    const response = await http.post(`/mpo/surveys/${surveyId}/submit-choice/`, choice)
    return response.data
  } catch (error) {
    console.error('Ошибка при сохранении выбора:', error)
    throw error
  }
}

export async function completeSurvey(surveyId) {
  try {
    const response = await http.post(`/mpo/surveys/${surveyId}/complete/`)
    return response.data
  } catch (error) {
    console.error('Ошибка при завершении опроса:', error)
    throw error
  }
}

export async function getSurveyResult(surveyId) {
  try {
    const response = await http.get(`/mpo/results/?survey=${surveyId}`)
    return response.data[0] || null
  } catch (error) {
    console.error('Ошибка загрузки результатов:', error)
    return null
  }
}

export async function getSociogramData(resultId) {
  try {
    const response = await http.get(`/mpo/results/${resultId}/sociogram_data/`)
    return response.data
  } catch (error) {
    console.error('Ошибка загрузки данных социограммы:', error)
    return null
  }
}

export async function getRecentSurveys() {
  try {
    const response = await http.get('/mpo/surveys/recent/')
    return response.data
  } catch (error) {
    console.error('Ошибка загрузки опросов:', error)
    return []
  }
}

export async function getSurvey(surveyId) {
  try {
    const response = await http.get(`/mpo/surveys/${surveyId}/`)
    return response.data
  } catch (error) {
    console.error('Ошибка загрузки опроса:', error)
    return null
  }
}

export async function getLatestRelations() {
  try {
    const { data } = await http.get('/mpo/relations/latest/')
    return data
  } catch (error) {
    console.error('Ошибка загрузки социометрических связей:', error)
    return { survey_id: null, classifications: {}, positive_pairs: [], negative_pairs: [] }
  }
}

// ---- Kiosk-режим прохождения (без авторизации) ----
// Используем fetch напрямую, минуя JWT-обёртку из http.js,
// чтобы токен админа не попал в публичный запрос.

function kioskUrl(token, suffix = '') {
  const base = getApiBase().replace(/\/$/, '')
  return `${base}/mpo/kiosk/${encodeURIComponent(token)}/${suffix}`
}

export async function getKioskState(token) {
  const resp = await fetch(kioskUrl(token), {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    credentials: 'omit',
  })
  if (!resp.ok) {
    throw new Error(`Kiosk state: ${resp.status}`)
  }
  return resp.json()
}

/**
 * Отправить ответы одного респондента.
 * choices: [{ question_id, chosen_user_id, choice_type: 'plus'|'minus', order }]
 */
export async function submitKioskChoices(token, respondentId, choices) {
  const resp = await fetch(kioskUrl(token, 'submit/'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'omit',
    body: JSON.stringify({ respondent_id: respondentId, choices }),
  })
  const data = await resp.json().catch(() => ({}))
  if (!resp.ok) {
    const err = new Error(data.error || `Kiosk submit: ${resp.status}`)
    err.payload = data
    throw err
  }
  return data
}